import { useQuery } from '@apollo/client';
import { GetGitHubBio } from '../gql/GetGitHubBio';
import { UserBase } from '../types/UserBase';
import '../scss/pages/Home.scss';
import React from 'react';
import { socialData } from '../data/SocialData';
import BoxWithIcon from '../components/BoxWithIcon';

const Home = () => {
  const username = 'DannyDorito';
  const { loading, error, data } = useQuery<UserBase>(GetGitHubBio, {
    variables: { name: username },
  });

 return (
  <>
  <div style={{paddingLeft:'250px' , fontSize:'50px'}}></div>
  <div style={{paddingLeft:'500px' , }} >
      <h5 style={{padding:'0px',marginBottom:'20px',fontSize:'50px'}}>Hi, I'm Rahul</h5>
      <div style={{fontSize:'30px'}}>I'm a Full Stack Developer</div>
      <ul  style={{fontSize:'15px', }}>
        <li style={{ marginBottom:'10px'}}>Based in India</li>
        <li style={{ marginBottom:'10px'}}>SDE at Easebuzz Payment Solutions</li>
        <li style={{ marginBottom:'10px'}}>email :   ragurnani.rg@gmail.com</li>
        <li style={{ marginBottom:'10px'}}>Ph number : +91 9552631665</li>
      </ul>
      <div className='icon-box'>
  {socialData.map((social) => (
          <BoxWithIcon
            props={{
              text: '',
              svg: social.icon,
              link: social.link,
              className: 'white',
            }}
            key={social.platform.toLowerCase()}
          />
        ))}
  </div>
  </div>
  </>
 )
};

export default Home;
